import { Typography, styled } from '@mui/material';

export const TitleWrapper = styled('div')`
  display: grid;
  grid-template-columns: auto 24px;
`;

export const Title = styled(Typography)`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;

export const CardTitle = styled(Title)`
  min-height: 48px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const FolderTitle = styled(Title)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: inherit;
`;
